module.exports = __webpack_public_path__ + "static/media/Badge_SvgAppBienvenue.0fb8d6aa.svg";